import http from './http';

export async function getStock(params = {}) {
  const { data } = await http.get('/api/inventory/stock', { params });
  return data;
}

export async function adjustStock(productId, qtyDelta, comment = '') {
  const { data } = await http.post('/api/inventory/adjust', { productId, qtyDelta, comment });
  return data;
}

export async function exportStockXlsx(params = {}) {
  const res = await http.get('/api/inventory/stock', {
    params: { ...params, export: 'xlsx' },
    responseType: 'blob',
    withCredentials: true,
  });
  return res.data; // Blob
}